import React from 'react';
import { Stack, Box, Button, useMediaQuery } from '@mui/material';
import { Link } from 'react-router-dom';
import { MdAdd } from 'react-icons/md';
import {
    GridToolbarQuickFilter,
    GridToolbarExport,
    GridToolbarFilterButton,
    GridToolbarColumnsButton
} from '@mui/x-data-grid-premium';

const ToolbarCrud = (props) => {
    const { resource, name, createLink, onCreateClick } = props;
    const isMobile = useMediaQuery('(max-width:600px)');
    const linkTo = createLink || `/admin/${resource}/new`;
    
    return (
        <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
            spacing={2}
            py={1}
        >
            {!isMobile && (
                <>
                    <Box color="secondary" display="flex" justifyContent="flex-end" alignItems="flex-start" >
                        <GridToolbarQuickFilter />
                    </Box>
                    <Stack
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                        spacing={3}
                    >
                        <GridToolbarColumnsButton />
                        <GridToolbarFilterButton />
                        <GridToolbarExport />
                        {onCreateClick ? (
                            <Button
                                variant="contained"
                                display="flex"
                                color="primary"
                                onClick={onCreateClick}
                                startIcon={<MdAdd />}
                            >
                                Create {name}
                            </Button>
                        ) : (
                            <Button
                                variant="contained"
                                display="flex"
                                color="primary"
                                component={Link}
                                to={linkTo}
                                startIcon={<MdAdd />}
                            >
                                Create {name}
                            </Button>
                        )}
                    </Stack>
                </>
            )}
            {isMobile && (
                <>
                    <Box color="secondary" display="flex" justifyContent="flex-end" alignItems="flex-start" >
                        <GridToolbarQuickFilter />
                    </Box>
                    <Stack
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                        spacing={3}
                    >
                        {onCreateClick ? (
                            <Button
                                variant="contained"
                                display="flex"
                                color="primary"
                                onClick={onCreateClick}
                                startIcon={<MdAdd />}
                            >
                                Create
                            </Button>
                        ) : (
                            <Button
                                variant="contained"
                                display="flex"
                                color="primary"
                                component={Link}
                                to={linkTo}
                                startIcon={<MdAdd />}
                            >
                                Create
                            </Button>
                        )}
                    </Stack>
                </>
            )}
        </Stack>
    );
}

export default ToolbarCrud;
